import React from "react";
import { useNavigate } from "react-router-dom";
import InitialLoader from "components/loader/InitialLoader";

// Renders a loader while navigating: the router transition keeps the last
// committed frame on screen until the destination tree commits, so the frame
// the user waits on must be a loader rather than an empty redirect stub.
const RedirectWithLoader = ({ to }) => {
  const navigate = useNavigate();
  React.useEffect(() => {
    navigate(to, { replace: true });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return <InitialLoader />;
};

export default RedirectWithLoader;
